import { useEffect } from 'react';
import { subscribe } from '../utils/dataBus';

/**
 * Re-runs `refetch` whenever something on this origin signals that the
 * budget figures for `departmentId` may have changed, OR when the user
 * switches back to this tab (visibilitychange → visible).
 *
 * Both paths are server-cost free until they fire — no polling.
 *
 *   const fetchReport = useCallback(() => { ... }, [departmentId, asOf]);
 *   useBudgetInvalidation(departmentId, fetchReport);
 */
export default function useBudgetInvalidation(departmentId, refetch) {
  useEffect(() => {
    if (!departmentId || typeof refetch !== 'function') return undefined;

    const unsub = subscribe('budget-changed', (payload) => {
      // Department filter: a notify with no departmentId is a "broadcast
      // to anyone watching" event; with one, only the matching dept
      // refetches. Coerce to Number because the bus may round-trip
      // through JSON.
      if (
        !payload ||
        payload.departmentId == null ||
        Number(payload.departmentId) === Number(departmentId)
      ) {
        refetch();
      }
    });

    const onVisible = () => {
      if (typeof document !== 'undefined' && document.visibilityState === 'visible') {
        refetch();
      }
    };
    if (typeof document !== 'undefined') {
      document.addEventListener('visibilitychange', onVisible);
    }

    return () => {
      unsub();
      if (typeof document !== 'undefined') {
        document.removeEventListener('visibilitychange', onVisible);
      }
    };
  }, [departmentId, refetch]);
}
